import { LoanContext } from "providers/loan";
import { useContext } from "react";
import { BankingInformationLine } from "./BankingInformationLine";
import { Flex, Text } from "@chakra-ui/react";
import { BankingInformationModel } from "../@types/banking-information.model";

export function BankingInformation() {
  const { loan } = useContext(LoanContext);

  const lien =
    loan?.values.find(f => f.loan_field.identifier_key === "loan_lien_type")?.value?.field ?? "";

  let bankingInformation: BankingInformationModel | null = null;

  if (lien) {
    if (lien.toLowerCase().includes("first")) {
      bankingInformation = {
        name: "Sonic Funding Capital 2 Ltd ",
        use: "1st charge loans",
        bank: "Weatherbys Acc",
        accountName: "Sonic Funding Capital 2 Ltd - Collections",
        accountNumber: "13015623",
        sortCode: "60-93-03",
      };
    } else {
      bankingInformation = {
        name: "Sonic Funding Capital 1 Ltd ",
        use: "2nd charge loans",
        bank: "Weatherbys",
        accountName: "Sonic Funding Capital 1 Ltd",
        accountNumber: "13015215",
        sortCode: "60-93-03",
      };
    }
  }

  if (!bankingInformation) {
    return null;
  }

  return (
    <Flex direction="column" gap={4}>
      <Flex direction="column" gap={4}>
        <Text color={"black"} fontWeight={"semibold"} fontStyle={"italic"}>
          Please transfer the payment to our bank account mentioned below:
        </Text>
        <Flex direction={"column"}>
          <BankingInformationLine title="Name:" value={bankingInformation.name} />
          <BankingInformationLine title="Use:" value={bankingInformation.use} />
          <BankingInformationLine title="Bank:" value={bankingInformation.bank} />
          <BankingInformationLine title="Account Name:" value={bankingInformation.accountName} />
          <BankingInformationLine
            title="Account Number:"
            value={bankingInformation.accountNumber}
          />
          <BankingInformationLine title="Sort Code:" value={bankingInformation.sortCode} />
        </Flex>
        <hr />
      </Flex>
    </Flex>
  );
}
